import React from 'react';

import cx from 'classnames';
import { UseFormReturn } from 'react-hook-form';

import { TagsInputAdapter } from 'components/shared/HookFormComponents';
import Text from 'components/shared/Typography/Text';

import sharedStyles from '../../../../shared/index.module.css';
import { DefaultFormValues } from '../../types';

type TagsField = Pick<DefaultFormValues, 'tags'>;

type Props<T extends TagsField> = {
  methods: UseFormReturn<T>;
};

function TagsSection<T extends TagsField>({ methods }: Props<T>) {
  const { control, getValues } = methods;
  const isDisabled = getValues().tags.length > 2;

  return (
    <>
      <div className={sharedStyles.headlineContainer}>
        <Text type="brandon" isStrong className={cx(sharedStyles.cssTitle, sharedStyles.titleContainer)}>
          Tags
        </Text>
        <Text type="brandon" className={sharedStyles.descriptionText}>
          Tags allow you to create tailored versions of your content pages for different audiences and/or seasons. You
          can leave blank if this is the only version of this page.
        </Text>
      </div>

      <div className={sharedStyles.sectionContainer}>
        <TagsInputAdapter type="primary" name="tags" control={control} placeholder="Enter Tags" disabled={isDisabled} />
      </div>
    </>
  );
}

export { TagsSection };
